import { useRouter } from 'next/router';
import type queryString from 'query-string';

import useUrlState, { type Query } from './useUrlState';

export default function useNextUrlState<T extends Query>(option?: {
  stringifyOption?: queryString.StringifyOptions;
  routerOptions?: { shallow: boolean };
  isReplace?: boolean;
}) {
  const { stringifyOption, routerOptions, isReplace } = option || {};
  const router = useRouter();
  const { value, setValue } = useUrlState<T>({
    router,
    isReplace,
    option: stringifyOption,
    routerOptions,
  });

  return {
    fetchQuery: (newValue: Partial<T>) => setValue((prevValue) => ({ ...prevValue, ...newValue })),
    value,
    setValue,
  };
}
